module.exports = __webpack_public_path__ + "assets/c865bc93af98e011cbaf425b3e51876f.png";